var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing"},[_c('img',{attrs:{"src":_vm.url,"alt":""}}),_c('span',{staticClass:"com-font16"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }